<div class="sub-tab-container-class detail-tab-additional" style="background: white!important">
	<div class="dwform" style="padding-right: 15px;">

		<div class="dwform-cell-nopadding" style="min-width: 500px;">
			

			<div class="dwform-row">

				<label class="label-field" style="vertical-align: top">
					Raw NDC Number:</label> <span class="form-required">*</span> <input
					#ndcNumber id="ndcNumber" style="width: 120px"
					[(ngModel)]="valRawNDCNumber"
					(focusout)="onNDCFocusOut()"
					maxlength="14" />
			</div>

			  <div class="dwform-row-gap"></div>

			<div class="dwform-row">

				<label class="label-field" style="vertical-align: top">
					Orig NDC Number:</label><span class="form-required">*</span><input
					#omNDCNumber id="omNDCNumber" style="width: 120px"
					[(ngModel)]="valOMNDCNumber" /> <label
					style="margin-left: 107px; margin-right: 10px;">Format:</label>
				<dw-dropdown 
					[selectedItem]="selectedNdcFormat?.id" [dataSource]="ndcFormatList"
					(itemSelected)="formatNdc($event)" [controlWidth]="'116px'">

				</dw-dropdown>
			</div>

			  <div class="dwform-row-gap"></div>

                        <div class="dwform-row"  >
                            <label class="label-field" style="vertical-align: top">Med. Family:</label> <span
                                class="form-required">*</span>

                            <textarea class="text-area-override" [disabled]="true"
                                      style="background-color: transparent;margin-right: 10px;"
                                      [(ngModel)]="valMedicationFamily"></textarea>
                            <div style="display:table-cell;vertical-align: middle; width:100px;">
                                <button mat-button class="command-button" #medicationFamily id="medicationFamily"
                                        (click)="showMedFamilySelection()"
                                        matTooltip="Set medication family"
                                        style="scale: 85%;width:90px;">
                                    <mat-icon>add_circle_outline</mat-icon>
                                    Set
                                </button>
                            </div>
                        </div>

                        <div class="dwform-row-gap"></div>

                        <div class="dwform-row">
                            <label class="label-field" style="vertical-align: top">Description:</label>
                            <span class="form-required" >*</span>

                            <textarea #desc class="input-field text-area-override" placeholder="<description>"
                                      style="text-transform: uppercase"
                                      [(ngModel)]="valDesc"></textarea>
                        </div>

						 <div class="dwform-row-gap"></div>
                            <div class="dwform-row">
                                <label class="label-field">Storage:</label> <span
                                    class="form-required"></span>
                                <textarea class="input-field text-area-override"
                                        placeholder="<storage instructions>"
                                        style="vertical-align:top; height: 60px; width: 398px;
                                        text-transform: uppercase"
                                        [(ngModel)]="valStorageInstructions"></textarea>
                            </div>
                         <div class="dwform-row-gap"></div>
                                <div class="dwform-row">
                                <label class="label-field">Manu. By:</label>
                                    <span class="form-required"></span>

                                    <dw-dropdown 
                                                 [selectedItem]="selectedManuBy?.id"
                                                 [dataSource]="manufactureByList"
                                                 (itemSelected)="manuBySelected($event)"
                                                 [controlWidth]="'398px'"
                                                 [enableSearch]="true"
                                                 matTooltip="Select manufactured by">
                                    </dw-dropdown>
                                     <div style="display:table-cell;vertical-align: middle; width:100px;">
		                                <button mat-button class="command-button"
		                                        (click)="showQuickAddManuBy()"
		                                        matTooltip="Add New Manufacturer"
		                                        style="scale: 85%;width:90px;">
		                                    <mat-icon>add_circle_outline</mat-icon>
	                                    	Add
	                                	</button>
                            		</div>
                                </div>
                            <div class="dwform-row-gap"></div>
                            <div class="dwform-row">
                                <label class="label-field">Manu. For:</label>
                                <span class="form-required"></span>

                                    <dw-dropdown 
                                                 [selectedItem]="selectedManuFor?.id"
                                                 [dataSource]="manufactureForList"
                                                 (itemSelected)="manuForSelected($event)"
                                                 [controlWidth]="'398px'"
                                                 [enableSearch]="true"
                                                 matTooltip="Select manufactured for">
                                    </dw-dropdown>
                                     <div style="display:table-cell;vertical-align: middle; width:100px;">
		                                <button mat-button class="command-button"
		                                        (click)="showQuickAddManuFor()"
		                                        matTooltip="Add New Manufacturer"
		                                        style="scale: 85%;width:90px;">
		                                    <mat-icon>add_circle_outline</mat-icon>
	                                    	Add
	                                	</button>
                            		</div>

                            </div>
                            <div class="dwform-row-gap"></div>
                            <div class="dwform-row">
	                            <label class="label-field">Pkg Size:</label> <span
	                                class="form-required">*</span> <input class="input-field"
	                                     id="packagesize" placeholder="<size>"
	                                     [(ngModel)]="valPkgSize" type="text" style="width: 80px">
	                                     
	                              <label class="label-field-short" style="width: 40px;margin-left: 22px;">AWP:</label> <span
                                    class="form-required"></span>
	                                <p-inputNumber [inputStyleClass]="'input-field'"
	                                               placeholder="<awp>"
	                                               [(ngModel)]="valAWP" mode="currency" currency="USD"
	                                               locale="en-US" type="text"
	                                               [inputStyle]="{'width': '80px', 'background':'white'}">
	
	                                </p-inputNumber>
	                                  <label class="label-field-short" style="width: 40px;margin-left: 10px;">Price:</label> <span
                                    class="form-required"></span>
	                                <p-inputNumber [inputStyleClass]="'input-field'"
	                                               placeholder="<awp>"
	                                               [(ngModel)]="valPrice" mode="currency" currency="USD"
	                                               locale="en-US" type="text"
	                                               [inputStyle]="{'width': '80px', 'background':'white'}">
	
	                                </p-inputNumber>
                        	</div> 
                        	
                        	<div class="dwform-row-gap"></div>
                          <div class="dwform-row">
							  <label class="label-field">Images:</label> <span class="form-required">*</span>
							
							  <mat-tab-group class="custom-tab-group input-field" selectedIndex="imageTabIndex"
							                 (selectedTabChange)="doImageSelectedTabChange($event)">
							
							    <!-- Container Tab -->
							    <mat-tab label="Container">
							   	  <div style="margin-top:10px;margin-bottom: 10px;">
								      <mat-radio-group [(ngModel)]="containerInputMethod">
								        <mat-radio-button  style="padding-left: 3px;" value="paste">Paste Image</mat-radio-button>
								        <mat-radio-button style="padding-left: 9px;" value="file">Upload File</mat-radio-button>
								      </mat-radio-group>
							      </div>
							
							      <app-paste-selector *ngIf="containerInputMethod === 'paste'"
							                          (onPasteSelected)="onPasteSelectedHandler($event)">
							      </app-paste-selector>
							
							      <app-file-selector *ngIf="containerInputMethod === 'file'"
							                         [file_types]="'PNG, JPG, JPEG, GIF'" 
							                         [header]="'Upload your images'"
							                         (onFileSelected)="onFileSelectedHandler($event)"
							                         (fileError)="onFileErrorHandler($event)">
							      </app-file-selector>
							    </mat-tab>

								    <!-- Dose Tab -->
								    <mat-tab label="Dose">
								     <div style="margin-top:10px;margin-bottom: 10px;">
									      <mat-radio-group [(ngModel)]="doseInputMethod">
									        <mat-radio-button style="padding-left: 3px;" value="paste">Paste Image</mat-radio-button>
									        <mat-radio-button style="padding-left: 9px;" value="file">Upload File</mat-radio-button>
									      </mat-radio-group>
									 </div>
								      <app-paste-selector *ngIf="doseInputMethod === 'paste'"
								                          (onPasteSelected)="onDosePasteSelectedHandler($event)">
								      </app-paste-selector>
								
								      <app-file-selector
										  *ngIf="doseInputMethod === 'file'"
										  [file_types]="'PNG, JPG, JPEG, GIF'" 
										  [header]="'Upload your dose images'"
										  (onFileSelected)="onDoseFileSelectedHandler($event)"
										  (fileError)="onFileErrorHandler($event)">
										</app-file-selector>
								
								    </mat-tab>
								
								  </mat-tab-group>
								  <div style="display:table-cell;vertical-align: middle; width:100px;">
		                               <button mat-button class="command-button"
										        (click)="openMedlineLink(valOMNDCNumber)"
										        matTooltip="Open Medline"
										        style="scale: 85%; width:90px;">
										    MedLine
										</button>
                            		</div>
								</div>

							</div>
					
						</div>

	<div [hidden]='!strErr.length' style="left: 10px;"
					class="error-line">{{strErr}}</div>
				<!-- save strip -->
				<div class="save-close-strip" style="bottom: 5px;">

					<button mat-button class="command-button" 
						(click)="submitRecord()" matTooltip="Submit the selected record"
						mat-button>
						<mat-icon>check_circle_outline</mat-icon>
						Submit
					</button>
					<button mat-button class="command-button" (click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
						<mat-icon>highlight_off</mat-icon>
						Cancel
					</button>
				</div>

</div>

<p-dialog header="Medication Family Lookup" [focusOnShow]="false"
          [(visible)]="displayMedFamilyDlg" [modal]="true"
          [style]="{width: '730px', height: '550px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-medfamlookup #medFamilyLookup
        [MedFamRecords]="medicationFamilyList"
        (cancelClicked)="displayMedFamilyDlg=false"
        (submitClicked)="setMedicationFamilyRecord($event)">
    </app-medfamlookup>
</p-dialog>

<p-dialog header="Quick Add (Manufactured-For)" [focusOnShow]="false"
          [(visible)]="displayManuForDlg" [modal]="true"
          [style]="{width: '600px', height: '300px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-quickaddmanufor #quickAddManuFor
        (cancelClicked)="displayManuForDlg=false"
        (submitClicked)="setManuForRecord($event)">
    </app-quickaddmanufor>
</p-dialog>

<p-dialog header="Quick Add (Manufactured-By)" [focusOnShow]="false"
          [(visible)]="displayManuByDlg" [modal]="true"
          [style]="{width: '600px', height: '250px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-quickaddmanuby #quickAddManuBy
        (cancelClicked)="displayManuByDlg=false"
        (submitClicked)="setManuByRecord($event)">
    </app-quickaddmanuby>
</p-dialog>

